import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { shopProducts, shopCategories } from '../data/shopData';
import ProductCard from './ProductCard';
import PricingComparison from './PricingComparison';
import SafeIcon from '../common/SafeIcon';
import { FiDollarSign, FiZap, FiShield, FiArrowDown } from 'react-icons/fi';

const PricingPage = () => {
  const [currency, setCurrency] = useState('MXN');

  return (
    <div className="min-h-screen bg-black pt-32 pb-20">
      <Helmet>
        <title>Precios y Planes 2026 | Online Classes English</title>
        <meta name="description" content="Consulta nuestro catálogo completo de precios para clases individuales, paquetes mensuales y especialidades de inglés." />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4">
        {/* Header Exhaustive */}
        <div className="text-center mb-24">
          <div className="inline-flex bg-zinc-900 border border-zinc-700 rounded-full p-1 mb-8">
            <button onClick={() => setCurrency('MXN')} className={`px-10 py-3 rounded-full text-xs font-black transition-all ${currency === 'MXN' ? 'bg-yellow-500 text-black shadow-lg shadow-yellow-500/20' : 'text-gray-500'}`}>PESOS (MXN)</button>
            <button onClick={() => setCurrency('USD')} className={`px-10 py-3 rounded-full text-xs font-black transition-all ${currency === 'USD' ? 'bg-yellow-500 text-black shadow-lg shadow-yellow-500/20' : 'text-gray-500'}`}>DÓLARES (USD)</button>
          </div>
          <h1 className="text-6xl md:text-9xl font-black text-white mb-8 uppercase italic tracking-tighter leading-none">
            Catálogo <span className="text-yellow-500">2026</span>
          </h1>
          <p className="text-2xl text-gray-400 max-w-3xl mx-auto font-medium mb-12">
            Desplázate para ver todas nuestras opciones. Desde clases individuales hasta inmersión total.
          </p>
          <div className="animate-bounce flex justify-center text-yellow-500">
            <SafeIcon icon={FiArrowDown} className="text-4xl" />
          </div>
        </div>

        {/* Categories Loop - Exhaustive Scrolling */}
        {shopCategories.map((category) => {
          const products = shopProducts.filter(p => p.category === category.id);
          return (
            <section key={category.id} className="mb-32">
              <div className="flex items-center gap-6 mb-12 border-b border-zinc-900 pb-6">
                <div className="w-16 h-16 bg-zinc-900 rounded-2xl flex items-center justify-center text-yellow-500 border border-zinc-800">
                  <SafeIcon icon={category.icon} className="text-3xl" />
                </div>
                <div>
                  <h2 className="text-4xl font-black text-white uppercase italic tracking-tight">{category.name}</h2>
                  <p className="text-gray-500 font-bold uppercase text-xs tracking-widest">{products.length} Programas Disponibles</p>
                </div>
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {products.map(product => (
                  <ProductCard key={product.id} product={product} currency={currency} />
                ))}
              </div>
            </section>
          );
        })}

        <PricingComparison />

        {/* Satisfaction Block */}
        <div className="mt-32 bg-gradient-to-br from-zinc-900 to-black border border-zinc-800 rounded-[4rem] p-16 text-center shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 p-12 opacity-5 text-green-500">
                <SafeIcon icon={FiShield} className="text-[20rem]" />
            </div>
            <div className="w-24 h-24 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-10 border-2 border-green-500 relative z-10">
                <SafeIcon icon={FiShield} className="text-5xl text-green-500" />
            </div>
            <h3 className="text-4xl md:text-6xl font-black text-white mb-8 uppercase relative z-10">Garantía de Satisfacción Total</h3>
            <p className="text-2xl text-gray-400 max-w-3xl mx-auto mb-12 relative z-10 leading-relaxed">
                Prueba cualquier plan. Si después de <span className="text-white font-bold">3 clases</span> sientes que no es para ti, te devolvemos el <span className="text-green-500 font-black">100% de tu dinero</span> sin preguntas.
            </p>
            <a href="https://wa.me/529844594738" className="inline-block bg-white text-black px-16 py-6 rounded-[2rem] font-black uppercase text-xl hover:bg-yellow-500 transition-all shadow-2xl relative z-10">
                Hablar con un Mentor
            </a>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;